import React from 'react'
import { ButtonBlue } from '../Buttons/ButtonBlue'
import imgSuccess from '../../assets/icons/success-entry-icon.svg';
import './messagesScreens.css';

const SuccessScreen = ({ title, description, image = imgSuccess, withButton = false, buttonTitle, onClickButton }) => {
    return (
        <div className='d-flex flex-column align-items-center justify-content-center gap-3'>
            <div>
                <img src={image} alt="" />
            </div>
            <p className='m-0 title-msg-screens'>{title}</p>
            <p className='description-msg-screens'>{description}</p>

            {
                withButton ?
                    <ButtonBlue className='w-100' onClick={onClickButton}>
                        {buttonTitle}
                    </ButtonBlue>
                    :
                    null
            }

        </div>
    )
}

export default SuccessScreen